import { Helmet } from 'react-helmet-async';
import { Grid } from '@mui/material';
import FacilityAccountsTable from '../../../components/dashboard/admin/facility-accounts/FacilityAccountsTable';

export default function FacilityAccounts() { 

  return (
    <>
      <Helmet>
        <title>Admin Facility Accounts | Platform Solutions</title>
      </Helmet>

      <Grid item xl={12}>
        <FacilityAccountsTable />
      </Grid>
    </>
  );
}
